import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import logo from '../../Assets/logo.png';
import { FaLinkedin, FaYoutube, FaGlobe, FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ behavior: 'smooth' });
    window.scrollTo({ top: 0});
  };

  const navigateAndScroll = (sectionId) => {
    if (location.pathname === "/") {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: sectionId } });
    }
  }


  const handleOnClickAiAgents = () => {
    scrollToTop();
    navigate('/aiAgents');
  }

  const handleModelAgnosticClick = () => {
    navigateAndScroll("model-agnostic");
  };

  const handleCopilorDataClick = () => {
    navigateAndScroll("copilot-data-section");
  };

  const handleSupportClick = () => {
    navigateAndScroll("support-section");
  };

  const handleBookDemoClick = () => {
    scrollToTop();
    navigate('/bookdemo');
  };

  const handleAboutUsClick = () => {
    navigateAndScroll("copilot-data-section")
  };

  const handlePricingClick = () => {
    scrollToTop();
    navigate('/pricing');
  };

  const handleContactViaMail = () => {
    window.open("mailto:support@xenachat.com", "_self");
  };


  return (
    <>
      <footer className="footer">
        <div className="footer-content">

          {/* Brand */}
          <div className="footer-brand">
            <img src={logo} alt="Xenachat Logo" className="footer-logo" />
          </div>

          {/* Certifications */}
          <div className="footer-certifications">
            <div><span className="emoji">🔒</span> SOC 2 Certified</div>
            <div><span className="emoji">🛡️</span> GDPR Compliant</div>
          </div>

          {/* Platform column */}
          <div className="footer-col footer-col-platform">
            <h4>Platform</h4>
            <ul>
              <li onClick={handleOnClickAiAgents}>AI Agents</li>
              <li onClick={handleCopilorDataClick}>Copilots with your Data</li>
              <li onClick={handleSupportClick}>24/7 Support</li>
              <li onClick={handleModelAgnosticClick}>Model Agnostic</li>
            </ul>
          </div>

          {/* Company column */}
          <div className="footer-col footer-col-company">
            <h4>Company</h4>
            <ul>
              <li onClick={handleBookDemoClick}>Request Demo</li>
              <li onClick={handleAboutUsClick}>About Us</li>
              <li onClick={handlePricingClick}>Pricing</li>
              <li onClick={handleContactViaMail}>Contact</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p>© 2026 Xenachat, Inc.</p>

          <div className="footer-links">
            <span>Terms</span>
            <span>Privacy</span>
            <span>Security</span>
          </div>

          <div className="footer-socials">
            <FaLinkedin />
            <FaXTwitter />
            <FaYoutube />
            <FaGlobe />
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
